import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { PasswordInput, EmailInput } from "./Inputs";
import { Link } from "react-router-dom";
import "../css/login.css";

import { login } from "../helpers/auth.js";
import { AlertsContext } from "./Layout";
import { authenticatedContext } from "../App";

function LoginForm() {
  const [passInput, setPassInput] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const addAlertBanner = useContext(AlertsContext);
  let navigate = useNavigate();
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);


  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage("");
    if (emailInput === "" || passInput === "") {
      setErrorMessage("Vyplňte všechny údaje");
      return;
    }
    setIsLoading(true);

    login(emailInput, passInput).then((res) => {
      try {
        setIsLoading(false);
        if (res.status === 200) {
          addAlertBanner("Přihlášení proběhlo úspěšně", "success");
          setAuthenticated(true);
          navigate('/');
        }
        else if (res.status === 401) {
          addAlertBanner("Nesprávné přihlašovací údaje", "warning");
        }
        else {
          addAlertBanner("Něco se pokazilo", "danger");
        }
      } catch (err) {
        addAlertBanner("Něco se pokazilo", "danger");
      }
    });

  };

  return (
    <form className="loginForm" onSubmit={handleSubmit}>
      <p className="formTitle">Přihlášení uživatele</p>
      <label htmlFor="email" className="visually-hidden">
        Enter your email
      </label>
      <EmailInput emailInput={emailInput} setEmailInput={setEmailInput} />
      <PasswordInput passInput={passInput} setPassInput={setPassInput} />
      <label htmlFor="password" className="visually-hidden">
        Enter your password
      </label>
      <button type="submit" className="submitButton" disabled={isLoading}>
        přihlásit se
      </button>
      {errorMessage && <div className="form-error-mess">{errorMessage}</div>}
    </form>
  );
}

function LoginPage() {
  return (
    <>
      <main className="mainContent">
        <header className="banner">
          <img
            loading="lazy"
            src="/img/svg/logo_bg.svg"
            alt="Peer Sight Logo"
          />
          <section className="systemInfo">Chytrý evidenční systém</section>
        </header>
        <section className="loginSection">
          <LoginForm />
          <div className="login-info">
            <div className="forgotPassword">
              Zapomněli jste heslo nebo se přihlašujete poprvé? Nastavte si nové heslo {" "}
              <Link to="/reset_pass" className="resetLink">
                zde
              </Link>
              .
            </div>
            <p className="accountRequest">
              Pro vytvoření uživatelského účtu požádejte administrátora vaší
              organizace.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}

export default LoginPage;
